import { Route, Routes } from 'react-router-dom';
import { Home } from '../components/Home/Home';
import { PATH_OF_ROUTES } from '../router/routes';
import { Web3InteractionSuccess } from '../components/Web3InteractionSuccess/Web3InteractionSuccess';
import { Web3InteractionSuccessType } from '../components/Web3InteractionSuccess/Web3InteractionSuccessType';
import { ClaimWeb3Interaction } from '../components/ClaimWeb3Interaction/ClaimWeb3Interaction';

export const App = () => {
  return (
    <Routes>
      <Route path={`${PATH_OF_ROUTES.BASE}`} element={<Home />} />
      <Route
        path={`/${PATH_OF_ROUTES.CLAIM_WEB3_INTERACTION}`}
        element={<ClaimWeb3Interaction />}
      />
      <Route
        path={`/${PATH_OF_ROUTES.CLAIM_WEB3_INTERACTION_SUCCESS}`}
        element={
          <Web3InteractionSuccess
            successType={Web3InteractionSuccessType.Claim}
          />
        }
      />
    </Routes>
  );
};
